import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/coupons`;

const CouponManager = {
  // Get coupon by ID
  async getCouponById(id) {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  async validateCouponByCode({ code, userId, planId, packageId }) {
    const response = await axios.post(`${BASE_URL}/validate`, {
      code,
      userId,
      planId,
      packageId,
    });
    return response.data;
  },

  // Get all coupons
  async getAllCoupons() {
    const response = await axios.get(BASE_URL);
    return response.data;
  },

  // Get available coupons for a user
  async getAvailableCouponsForUser(userId) {
    const response = await axios.get(`${BASE_URL}/user/${userId}/available`);
    return response.data;
  },

  // Get available coupons by type for a user
  async getAvailableCouponsByTypeForUser(userId, type) {
    const response = await axios.get(`${BASE_URL}/user/${userId}/available/type/${type}`);
    return response.data;
  },

  // Get coupons by type
  async getCouponsByType(type) {
    const response = await axios.get(`${BASE_URL}/type/${type}`);
    return response.data;
  },

  // Validate a coupon for a specific user
  async validateCouponForUser(couponId, userId) {
    const response = await axios.get(`${BASE_URL}/${couponId}/validate/user/${userId}`);
    return response.data;
  },

  // Create a coupon
  async createCoupon(couponDTO) {
    const response = await axios.post(BASE_URL, couponDTO);
    return response.data;
  },

  // Create a coupon for a specific user
  async createCouponForUser(userId, couponDTO) {
    const response = await axios.post(`${BASE_URL}/user/${userId}`, couponDTO);
    return response.data;
  },

  // Update a coupon
  async updateCoupon(id, couponDTO) {
    const response = await axios.put(`${BASE_URL}/${id}`, couponDTO);
    return response.data;
  },

  // Delete a coupon
  async deleteCoupon(id) {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.data;
  }
};

export default CouponManager;
